import api from "./axiosInstance";
import apiRoutes from "./api_route";

export const fetchMyCases = async () => {
  const response = await api.get(apiRoutes.cases.myCases);
  return response.data;
};

export const quickViewDetails = async (values) => {
  try {
    const response = await api.post(apiRoutes.cases.quickViewDetails, {
      values,
    });
    return JSON.parse(response?.data?.data?.[0]?.result);
  } catch (error) {
    return [];
  }
};

export const getCaseDocuments = async (values) => {
  const response = await api.post(apiRoutes.cases.caseDocuments, {
    caseDetailsID: values.caseDetailsID,
  });
  return response.data;
};

export const downloadCaseDocument = async (fileName) => {
  const response = await api.get(apiRoutes.documents.caseDownload(fileName), {
    responseType: "blob",
  });
  return response.data;
};

export const createCaseDocument = async (formData) => {
  const response = await api.post(apiRoutes.cases.createCaseDoc, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};
